<template>
  <div>
    <div v-if="!loading" id="btn_container">
    <v-btn :disabled="currentPage <= 0" @click="changePage(--currentPage)" icon>
      <v-icon >keyboard_arrow_left</v-icon>
    </v-btn>

    <v-btn :disabled="currentPage >= response.count - 1" @click="changePage(++currentPage)" icon>
      <v-icon>keyboard_arrow_right</v-icon>
    </v-btn>
  </div>
    <v-progress-linear  v-if="loading && !disableLoading" indeterminate ></v-progress-linear>
    <CanvasMark  v-on:marked="textMarked($event)" :dpi="response.dpi" :archiveImgSrc="archiveImgSrc"/>
  </div>
</template>

<script>
import Messenger from "@/plugins/Messenger";
import CanvasMark from "@/components/common/CanvasMark";

export default {
  name: "DocImageManager",
  components: {CanvasMark},
  props:['schemaId','formId','documentId', 'disableLoading'],
  data() {
    return {
      archiveImgSrc : null,
      response : {},
      currentPage : 0,
      loading: false,
      targetDpi : 300
    }
  },
  methods: {
    changePage(page) {
      this.archiveImgSrc = 'data:image/jpeg;base64,' + this.response.pages[page].data
    },
    textMarked(event){
      if(event.block.area() < 10){
        return event.canvasManager.clean()
      }

      this.loading = true
      this.$http.post(this.getRecognizeBlockLink(),{block : event.block.scale(this.targetDpi/this.response.dpi)})
      .then(data => {
        event.canvasManager.redraw('green')
        this.$emit('textRecognized', {data : data.data.text, onFinish : ()=> event.canvasManager.clean()})
        this.loading = false
      })
    },
    loadImage() {
      this.loading = true
      this.$http.get(this.getPageLink())
          .then(data => {
                this.response = data.data
                this.loading = false
                this.changePage(0)
              })
          .catch((e)=> Messenger.emitSuccess("Problem z załadowaniem obrazu " +e))
    },
    getPageLink(){
      if(this.formId && this.schemaId){
        return `document/schema/${this.schemaId}/form/${this.formId}/pages`
      }else if(this.documentId){
        return `document/${this.documentId}/pages`
      }
    },
    getRecognizeBlockLink(){
      if(this.formId && this.schemaId){
        return `document/schema/${this.schemaId}/form/${this.formId}/ocr/block/page/${this.currentPage + 1 }`
      }else if(this.documentId){
        return `document/${this.documentId}/ocr/block/page/${this.currentPage + 1 }`
      }
    }
  },
  created() {
    this.loadImage()
  },
  mounted() {

  }
}
</script>

<style>
.form-fill-header {
  margin: 11px;
}

.v-list__tile {
  height: auto;
  margin: 16px 0;
}
</style>
